export default __webpack_public_path__ + "static/media/dv_6.b846826c.svg";